export default __webpack_public_path__ + "media/images/mailer/icon_cached-2811446eb7c720f825a31638e22301c8.png";